import { BottomDock } from "./sidebar";
import { MobileTabBar } from "./mobile-tab-bar";

/**
 * Today's navigation: the floating bottom dock on desktop, the floating tab
 * bar on phones. The new look has its own (components/new-look/menu.tsx and
 * phone-tabs.tsx).
 */
export function ClassicNav({ isMobile }: { isMobile: boolean }) {
  if (!isMobile) {
    return (
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex flex-col items-stretch w-fit">
        <BottomDock />
      </div>
    );
  }

  return (
    <div className="fixed bottom-3 left-3 right-3 z-50 flex flex-col items-stretch pb-safe pointer-events-none">
      {/* Black gradient fade behind nav — extends from above nav to bottom of screen */}
      <div className="absolute -top-10 -left-3 -right-3 -bottom-3 bg-gradient-to-b from-transparent via-black/70 to-black pointer-events-none" />
      {/* Nav bar */}
      <div className="relative glass-card border border-white/[0.08] rounded-2xl shadow-2xl pointer-events-auto">
        <MobileTabBar />
      </div>
    </div>
  );
}
